<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body text-center">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="my-0 font-bold"
          v-text="'Share with Organizations'"
        />
        <p>
          <strong v-text="'Note:'" /> Sending this communication will create a draft copy in the receiving organization's
          dashboard. Their admins will be notified and have the ability to make changes and publish/send at
          their discretion.
        </p>
        <p
          v-if="errorMessage"
          class="text-red"
          v-text="errorMessage"
        />
      </header>
      <div>
        <div class="flex justify-center items-baseline mt-4">
          <div class="input-organization">
            <input
              v-model="search"
              type="text"
              placeholder="Search"
            >
          </div>
          <div class="text-xs pl-4">
            <a
              href="#"
              @click.prevent="selectAllOrganizations"
              v-text="'Select All'"
            />
            |
            <a
              href="#"
              @click.prevent="selectNoOrganizations"
              v-text="'Select None'"
            />
          </div>
        </div>
        <ul class="scroll-checklist scroll-blue">
          <li
            v-for="organization in filteredOrganizations"
            :key="organization.uuid"
          >
            <input
              :id="`organization-${organization.uuid}`"
              :key="organization.uuid"
              v-model="selectedOrganizations"
              type="checkbox"
              :name="`organization-${organization.uuid}`"
              :value="organization.uuid"
            >
            <label
              :for="`organization-${organization.uuid}`"
              class="checkbox"
              v-text="organization.attributes.name"
            />
          </li>
          <li v-if="isLoading">
            <div
              class="text-sm text-center italic mb-4"
              v-text="'Loading...'"
            />
          </li>
          <li v-if="!filteredOrganizations.length && !isLoading">
            <div
              class="text-sm text-center italic mb-4"
              v-text="'No results'"
            />
          </li>
        </ul>
        <div class="modal-footer text-center mt-4">
          <button
            type="button"
            :disabled="selectedOrganizations.length === 0"
            :aria-disabled="selectedOrganizations.length === 0"
            class="btn"
            @click.prevent="sendToOrganizations"
            v-text="sendToOrganizationsText"
          />
          <a
            href="#"
            class="ml-4"
            @click.prevent="cancel"
            v-text="'Cancel'"
          />
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'SendCommToOrganizationsModal',
  data() {
    return {
      isLoading: false,
      search: '',
      selectedOrganizations: [],
      errorMessage: null,
    }
  },
  computed: {
    show() {
      return this.$root.openedModalId === 'sendCommToOrganizationsModal'
    },
    organizations() {
      return this.$store.state.union.sharesWith
    },
    sendToOrganizationsText() {
      return this.selectedOrganizations.length === 1
        ? 'Share with 1 organization'
        : `Share with ${this.selectedOrganizations.length} organizations`
    },
    filteredOrganizations() {
      if (this.organizations.length) {
        return this.organizations.filter((organization) => {
          return organization.attributes.name.toLowerCase().includes(this.search.toLowerCase())
        })
      }
      return []
    },
  },
  watch: {
    show() {
      if (this.show && !this.organizations.length) {
        this.isLoading = true

        this.$store.dispatch('unionGetSharesWith')
          .then(() => {
            this.isLoading = false
          })
      }
    },
  },
  methods: {
    sendToOrganizations() {
      this.errorMessage = null

      this.$store.dispatch('communicationShareWithOrganizations', {
        organizations: this.selectedOrganizations,
        communication: {
          id: this.$root.openedModalPayload.uuid,
          type: this.$root.openedModalPayload.attributes._type,
        },
      }).then(() => {
        this.$store.commit('baseAddNotification', {
          type: 'success',
          title: 'Success',
          text: `Communication successfully shared with ${this.selectedOrganizations.length} organization(s)!`,
        })

        this.close()
      }).catch((error) => {
        this.errorMessage = error.response.data.errors.communication[0]
      })
    },
    selectAllOrganizations() {
      this.selectedOrganizations = this.organizations.map(organization => organization.uuid)
    },
    selectNoOrganizations() {
      this.selectedOrganizations = []
    },
    close() {
      this.$root.closeModal()

      this.errorMessage = null

      const vm = this

      setTimeout(function () {
        vm.selectedOrganizations = []
        vm.search = ''
      }, 1000)
    },
    cancel() {
      this.close()
    },
  },
}
</script>
